import styled from "@emotion/styled";
import { Col, Radio, Tag, Typography } from "antd";
import { FC } from "react";
import type { FactoryParcelAddressLookupItem } from "services/factoryParcelApi";

const TEMP_ADDRESS_PREFIX = "parcel-temp-";

export const isParcelTempAddressId = (id?: string) =>
  !!id && id.startsWith(TEMP_ADDRESS_PREFIX);

export const createParcelTempAddressId = () =>
  `${TEMP_ADDRESS_PREFIX}${Date.now()}`;

const withAdminPrefix = (prefix: string, value?: string) => {
  const v = value?.trim();
  if (!v) return null;
  if (v.startsWith(prefix)) return v;
  return `${prefix}${v}`;
};

const formatLocationLine = (item: FactoryParcelAddressLookupItem) => {
  const segments = [
    withAdminPrefix("ตำบล", item.county),
    withAdminPrefix("อำเภอ", item.city),
    withAdminPrefix("จังหวัด", item.state),
    item.postcode?.trim() ? item.postcode.trim() : null,
  ].filter(Boolean);
  return segments.join(" ");
};

type ParcelDestinationAddressCardProps = {
  item: FactoryParcelAddressLookupItem;
  onSelect: (addressId: string) => void;
};

const ImageWrapper = styled.div``;

const TextWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const CardContainer = styled.div`
  position: relative;
  display: flex;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 16px;
  width: 100%;
  box-sizing: border-box;
`;

const FixedTag = styled(Tag)`
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 1;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
`;

/** การ์ดที่อยู่ปลายทาง — layout ตาม AgentAddressCard (ระบบสั่งซื้อ) ไม่มีประเภทขนส่ง */
const ParcelDestinationAddressCard: FC<ParcelDestinationAddressCardProps> = ({
  item,
  onSelect,
}) => {
  const locationLine = formatLocationLine(item);
  const radioValue = item.address_id;

  const handleRadioChange = () => {
    onSelect(radioValue);
  };

  return (
    <Col sm={12} md={8} xl={8} span={24} style={{ padding: "5px" }}>
      <CardContainer>
        {item.last_address ? (
          <FixedTag color="magenta">ที่อยู่จัดส่งล่าสุด</FixedTag>
        ) : null}
        <ImageWrapper>
          <Radio value={radioValue} onChange={handleRadioChange} />
        </ImageWrapper>
        <Content>
          <TextWrapper>
            <Typography.Text className="text-order-product-name">ชื่อ :</Typography.Text>
            <Typography.Text className="text-order-product-name">
              {item.fullname}
            </Typography.Text>
          </TextWrapper>

          <TextWrapper>
            <Typography.Text className="text-order-product-name">
              เบอร์โทรศัพท์ :
            </Typography.Text>
            <Typography.Text className="text-order-product-name">
              {item.telephone1}
            </Typography.Text>
          </TextWrapper>

          {item.address?.trim() ? (
            <TextWrapper>
              <Typography.Text className="text-order-product-name">
                ที่อยู่ : {item.address}
              </Typography.Text>
            </TextWrapper>
          ) : null}

          {locationLine ? (
            <TextWrapper>
              <Typography.Text className="text-order-product-name">
                {locationLine}
              </Typography.Text>
            </TextWrapper>
          ) : null}
        </Content>
      </CardContainer>
    </Col>
  );
};

export default ParcelDestinationAddressCard;
